import { NodeExtension, NodeGroup, toggleList, extensionDecorator, convertCommand, isElementDomNode, Preset, presetDecorator } from '@remirror/core';
import { wrappingInputRule } from '@remirror/pm/inputrules';
import { splitListItem, sinkListItem, liftListItem } from '@remirror/pm/schema-list';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';

var _dec, _class;
/**
 * Creates the node for a bullet list.
 */

var BulletListExtension = (_dec = /*#__PURE__*/extensionDecorator({}), /*#__PURE__*/_dec(_class = class BulletListExtension extends NodeExtension {
  get name() {
    return 'bulletList';
  }

  createNodeSpec(extra) {
    return {
      attrs: extra.defaults(),
      content: 'listItem+',
      group: NodeGroup.Block,
      parseDOM: [{
        tag: 'ul',
        getAttrs: extra.parse
      }],
      toDOM: node => ['ul', extra.dom(node), 0]
    };
  }

  createCommands() {
    return {
      /**
       * Toggle the bullet list.
       */
      toggleBulletList: () => toggleList(this.type, this.store.schema.nodes.listItem)
    };
  }

  createKeymap() {
    return {
      'Shift-Ctrl-8': toggleList(this.type, this.store.schema.nodes.listItem)
    };
  }

  createInputRules() {
    return [wrappingInputRule(/^\s*([*+-])\s$/, this.type)];
  }

}) || _class);

var _dec$1, _class$1;
/**
 * Creates the node for a list item.
 */

var ListItemExtension = (_dec$1 = /*#__PURE__*/extensionDecorator({}), /*#__PURE__*/_dec$1(_class$1 = class ListItemExtension extends NodeExtension {
  get name() {
    return 'listItem';
  }

  createNodeSpec(extra) {
    return {
      attrs: extra.defaults(),
      content: 'paragraph block*',
      defining: true,
      draggable: false,
      parseDOM: [{
        tag: 'li',
        getAttrs: extra.parse
      }],
      toDOM: node => ['li', extra.dom(node), 0]
    };
  }

  createKeymap() {
    return {
      Enter: convertCommand(splitListItem(this.type)),
      Tab: convertCommand(sinkListItem(this.type)),
      'Shift-Tab': convertCommand(liftListItem(this.type))
    };
  }

}) || _class$1);

var _dec$2, _class$2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * Creates the list for the ordered list.
 */

var OrderedListExtension = (_dec$2 = /*#__PURE__*/extensionDecorator({}), /*#__PURE__*/_dec$2(_class$2 = class OrderedListExtension extends NodeExtension {
  get name() {
    return 'orderedList';
  }

  createNodeSpec(extra) {
    return {
      attrs: _objectSpread(_objectSpread({}, extra.defaults()), {}, {
        order: {
          default: 1
        }
      }),
      content: 'listItem+',
      group: NodeGroup.Block,
      parseDOM: [{
        tag: 'ol',
        getAttrs: node => {
          var _node$getAttribute;

          if (!isElementDomNode(node)) {
            return {};
          }

          return _objectSpread(_objectSpread({}, extra.parse(node)), {}, {
            order: +((_node$getAttribute = node.getAttribute('start')) !== null && _node$getAttribute !== void 0 ? _node$getAttribute : 1)
          });
        }
      }],
      toDOM: node => {
        var extraAttributes = extra.dom(node);
        return node.attrs.order === 1 ? ['ol', extraAttributes, 0] : ['ol', _objectSpread(_objectSpread({}, extraAttributes), {}, {
          start: node.attrs.order
        }), 0];
      }
    };
  }

  createCommands() {
    return {
      /**
       * Toggle the ordered list for the current selection.
       */
      toggleOrderedList: () => toggleList(this.type, this.store.schema.nodes.listItem)
    };
  }

  createKeymap() {
    return {
      'Shift-Ctrl-9': toggleList(this.type, this.store.schema.nodes.listItem)
    };
  }

  createInputRules() {
    return [wrappingInputRule(/^(\d+)\.\s$/, this.type, match => ({
      order: +match[1]
    }), (match, node) => node.childCount + node.attrs.order === +match[1])];
  }

}) || _class$2);

var _dec$3, _class$3;
var ListPreset = (_dec$3 = /*#__PURE__*/presetDecorator({}), /*#__PURE__*/_dec$3(_class$3 = class ListPreset extends Preset {
  get name() {
    return 'list';
  }

  onSetOptions(_) {}

  createExtensions() {
    return [new OrderedListExtension(), new BulletListExtension(), new ListItemExtension()];
  }

}) || _class$3);

export { BulletListExtension, ListItemExtension, ListPreset, OrderedListExtension };
